import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IDriver } from '@/modules/driver/model/driver';
import { IPartner } from '@/modules/partner/model';
import { TAccessStatus } from '@/shared/models/access-status';
import { DescriptionList } from '@/shared/view/DescriptionList';

import { renderStatus } from './render-status';
import s from './styles.module.css';

const AccessStatusesSortedByPriority: readonly TAccessStatus[] = [
  'end_of_life',
  'partner_blocked',
  'failed_tests',
  'offboarded',
  'to_be_offboarded',
  'blocked',
  'rejected',
  'expired_docs',
  'pending',
  'new_partner',
  'active',
];
const getStatusPriority = (toCheck: TAccessStatus) =>
  AccessStatusesSortedByPriority.indexOf(toCheck);
const getTopPriorityStatus = (...statuses: TAccessStatus[]): TAccessStatus =>
  statuses.sort((a, b) => getStatusPriority(a) - getStatusPriority(b))[0];

const StatusInfo = ({ partner, driver }: { partner: IPartner; driver: IDriver }) => {
  const intl = useIntl();

  return (
    <DescriptionList
      title={intl.formatMessage({
        defaultMessage: 'Status',
        id: 'ysGO2T',
        description: 'Profile screen: status section: subheader',
      })}
      className={s.values}
      values={useMemo(
        () => ({
          accessStatus: renderStatus(
            intl,
            getTopPriorityStatus(partner.accessStatus, driver.accessStatus),
          ),
        }),
        [intl, partner.accessStatus, driver.accessStatus],
      )}
      titles={useMemo(
        () => [
          [
            'accessStatus',
            intl.formatMessage({
              defaultMessage: 'Access',
              id: 'ncXy/y',
              description: 'Profile screen: status section',
            }),
          ],
        ],
        [intl],
      )}
    />
  );
};

export { StatusInfo, renderStatus };
